var _circle, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgeur(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "url(#paint0_linear_3_143)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7929 7.70711L9.70711 21.7929C9.31658 22.1834 9.31658 22.8166 9.70711 23.2071L15.7929 29.2929C16.1834 29.6834 16.8166 29.6834 17.2071 29.2929L23.7929 22.7071C24.1834 22.3166 24.8166 22.3166 25.2071 22.7071L31.7929 29.2929C32.1834 29.6834 32.8166 29.6834 33.2071 29.2929L39.2929 23.2071C39.6834 22.8166 39.6834 22.1834 39.2929 21.7929L25.2071 7.70711C24.8166 7.31658 24.1834 7.31658 23.7929 7.70711Z",
    fill: "white",
    stroke: "#43483F",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 39.8994V34H20.0996V34.6962H16.7503V36.503H19.8869V37.1952H16.7503V39.2032H20.2311V39.8994H16Z",
    fill: "#43483F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9882 34H25.7385V37.4085C25.7385 38.0013 25.674 38.4722 25.5451 38.8209C25.4162 39.1697 25.1828 39.4541 24.8451 39.674C24.5099 39.8913 24.069 40 23.5224 40C22.9912 40 22.5568 39.9048 22.219 39.7143C21.8812 39.5238 21.6402 39.2488 21.4958 38.8893C21.3514 38.5272 21.2792 38.0335 21.2792 37.4085V34H22.0295V37.4044C22.0295 37.9168 22.0746 38.2951 22.1649 38.5392C22.2577 38.7807 22.415 38.9671 22.6367 39.0986C22.861 39.23 23.1343 39.2958 23.4566 39.2958C24.0084 39.2958 24.4016 39.1657 24.6362 38.9054C24.8708 38.6452 24.9882 38.1449 24.9882 37.4044V34Z",
    fill: "#43483F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0031 39.8994V34H29.517C30.0224 34 30.4066 34.0537 30.6696 34.161C30.9326 34.2656 31.1427 34.452 31.3 34.7203C31.4573 34.9886 31.5359 35.285 31.5359 35.6097C31.5359 36.0282 31.4057 36.381 31.1453 36.668C30.8849 36.9551 30.4826 37.1375 29.9386 37.2153C30.1371 37.3146 30.288 37.4125 30.3911 37.5091C30.6103 37.7183 30.8178 37.9799 31.0138 38.2938L32 39.8994H31.0563L30.306 38.672C30.0869 38.3179 29.9064 38.0469 29.7646 37.8592C29.6228 37.6714 29.4951 37.5399 29.3817 37.4648C29.2708 37.3897 29.1574 37.3374 29.0413 37.3078C28.9562 37.2891 28.817 37.2797 28.6236 37.2797H27.7534V39.8994H27.0031ZM27.7534 36.6036H29.3662C29.7091 36.6036 29.9773 36.5674 30.1707 36.495C30.364 36.4199 30.511 36.3018 30.6116 36.1408C30.7121 35.9772 30.7624 35.8001 30.7624 35.6097C30.7624 35.3307 30.6644 35.1013 30.4685 34.9215C30.2751 34.7418 29.9683 34.6519 29.548 34.6519H27.7534V36.6036Z",
    fill: "#43483F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_143",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FBA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5CCA9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeur);
export default __webpack_public_path__ + "static/media/ageur.e4f3e363ee93820072cbec3413762b5c.svg";
export { ForwardRef as ReactComponent };